var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 1.3327V6.99937M9.33464 1.3327V6.99937",
    stroke: "#E6E6F5",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9441 1.34048H3.05587C2.44857 1.34048 1.64464 1.23553 1.22932 1.79671C1 2.10657 1 2.55493 1 3.45166C1 4.2162 1 4.59846 1.15462 4.92053C1.41872 5.4706 2.00918 5.70954 2.51528 5.9694L4.98754 7.23879C5.97508 7.74584 6.46885 7.99937 7 7.99937C7.53115 7.99937 8.02492 7.74584 9.01246 7.23879L11.4847 5.9694C11.9908 5.70954 12.5813 5.4706 12.8454 4.92053C13 4.59846 13 4.2162 13 3.45166C13 2.55493 13 2.10657 12.7707 1.79671C12.3554 1.23553 11.5514 1.34048 10.9441 1.34048Z",
    stroke: "#E6E6F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01818 9.09109C6.49722 8.80771 6.73675 8.66602 6.9987 8.66602C7.26065 8.66602 7.50017 8.80771 7.97922 9.09109L8.64589 9.48546C9.14315 9.77962 9.39178 9.9267 9.52857 10.1727C9.66536 10.4186 9.66536 10.7186 9.66536 11.3186V12.0134C9.66536 12.6134 9.66536 12.9134 9.52857 13.1594C9.39178 13.4053 9.14315 13.5524 8.64589 13.8466L7.97922 14.2409C7.50017 14.5243 7.26065 14.666 6.9987 14.666C6.73675 14.666 6.49722 14.5243 6.01818 14.2409L5.35151 13.8466C4.85424 13.5524 4.60561 13.4053 4.46882 13.1594C4.33203 12.9134 4.33203 12.6134 4.33203 12.0134V11.3186C4.33203 10.7186 4.33203 10.4186 4.46882 10.1727C4.60561 9.9267 4.85424 9.77962 5.35151 9.48546L6.01818 9.09109Z",
    stroke: "#E6E6F5",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeader);
export default __webpack_public_path__ + "static/media/leader.b1386c644d4e44e8180bb621f1df974f.svg";
export { ForwardRef as ReactComponent };